// Global majburiy zoom olib tashlandi — endi ekran o'lchamiga moslashish
// src/index.css dagi CSS clamp()/media query orqali amalga oshiriladi.
// getTextScale() shu sababli doim 1 qaytaradi (orqaga moslik uchun
// saqlanadi — QuizTopbar'dagi foydalanuvchi boshqaradigan ichki quiz-zoom
// funksiyasi applyTextScale/getTextScale'dan hali foydalanadi).
export function getTextScale(): number {
  return 1;
}

// Diqqat: bu ilgari `document.body.style.zoom`'ni o'zgartirar edi — bu esa
// brauzerning "effektiv ekran kengligi"ni ham o'zgartirib yuborar, natijada
// matnni kattalashtirganda (masalan 1.6x) desktop 2-ustunli ko'rinish
// to'satdan mobil 1-ustunli ko'rinishga o'tib qolar edi (lg: breakpoint
// zoom tufayli "ekran torайgandek" hisoblanardi) — foydalanuvchiga "teskari
// ishlayapti" bo'lib tuyular edi. Endi faqat CSS custom property orqali
// (--quiz-scale) FAQAT matn o'lchamini o'zgartiramiz — layout/breakpoint'ga
// butunlay tegilmaydi.
export function applyTextScale(scale: number) {
  document.documentElement.style.setProperty("--quiz-scale", String(scale));
}

export function initTextScale() {
  // Global zoom yo'q — hech narsa qilmaydi.
}
